import Helper from '@/resources/Helper';
import DBEngine from '@/database/_Base';
import SyncEngine from '@/database/_Sync';

const tableName = 'stockHistory';

// NOTE: Stock history is using different method from the others, so the function will be unique by itself

const functions = {
    async getHistoryByInventory(key) {
        // Sync Data First
        await this.syncByKey(key);

        // Get Data of This Inventory Key
        return await this.getByKey(key);
    },
    async getByKey(key) {
        const db = await DBEngine.getDb();
        
        return new Promise(resolve => {
            const trans = db.transaction([tableName], 'readonly');
            const store = trans.objectStore(tableName);
            const request = store.get(key);

            request.onsuccess = (e) => {
                resolve(e.target.result);
            };
		});
    },
    async getVersionByKey(key) {
        const history = await this.getByKey(key);

        if (history) {
            return history.version;
        }

        return null;
    },
    async syncByKey(key) {
        const currentVersion = await this.getVersionByKey(key);
		// const path = '/api/sync-data/sync-stock-history';
		const param = {
			storeId: 1, // Store ID,
            inventoryKey: key,
			clientVersion: currentVersion
		};

		console.log('Sync Data "' + tableName + '" with param ', param);
		
		// const data = await Helper.postAPI(Helper.getApiUrl(), path, param);

        // if (data) {
        //     if (data.isRequireUpdate) {
        //         await this.addNewVersionData(key, data.result);
        //     }
        // }
    },
    async addNewVersionData(key, result) {
        const dataKey = key;
        const dataStore = {
            version: result.version,
            content: result.data,
            timestamp: Helper.getClientTime()
        };
        
        const db = await DBEngine.getDb();

		return new Promise(resolve => {
			const trans = db.transaction([tableName], 'readwrite');
            const store = trans.objectStore(tableName);
            
			trans.oncomplete = () => {
				resolve();
			};

			store.put(dataStore, dataKey);
		});
    },
    async save(value) {
        const dataKey = value.inventoryKey;
        const dataStore = {
            version: 0,
            content: [],
            timestamp: Helper.getClientTime()
        };

        // Get Current Data by Key
        const currentData = await this.getHistoryByInventory(dataKey);

        if (currentData) {
            dataStore.version = currentData.version;
            dataStore.content = currentData.content;
        }

        dataStore.content.push(value);

        const db = await DBEngine.getDb();

		return new Promise(resolve => {
			const trans = db.transaction([tableName], 'readwrite');
            const store = trans.objectStore(tableName);
            
			trans.oncomplete = () => {
				resolve();
			};

			store.put(dataStore, dataKey);

            // Sync Pipeline
            SyncEngine.setupSyncPipeline(tableName, DBEngine.syncAction().add, value);
		});
    },
    async update(inventoryKey, contentData) {
        const dataKey = inventoryKey;
        const dataStore = {
            version: 0,
            content: [],
            timestamp: Helper.getClientTime()
        };

        // Get Current Data by Key
        const currentData = await this.getHistoryByInventory(dataKey);

        if (currentData) {
            dataStore.version = currentData.version;
            dataStore.content = contentData;

            const db = await DBEngine.getDb();

            return new Promise(resolve => {
                const trans = db.transaction([tableName], 'readwrite');
                const store = trans.objectStore(tableName);
                
                trans.oncomplete = () => {
                    resolve();
                };

                store.put(dataStore, dataKey);

                // Sync Pipeline
                SyncEngine.setupSyncPipeline(tableName, DBEngine.syncAction().add, contentData);
            });
        }
    }
}

export default functions;